function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 2.358,
  d: "M.244 1.228h49.713"
});

function SvgCalculatorIcon2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 3",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iMyIgdmlld0JveD0iMCAwIDUwIDMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxsaW5lIHgxPSIwLjI0NDE0MSIgeTE9IjEuMjI3OTUiIHgyPSI0OS45NTcyIiB5Mj0iMS4yMjc5NiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyLjM1NzU3Ii8+Cjwvc3ZnPgo=";
export { SvgCalculatorIcon2 as ReactComponent };